import React from 'react';
import './ParallaxFeaturesSection.css';

const ParallaxFeaturesSection = () => {
  return (
    <section className="prlx-features-wrapper">
      <div className="prlx-bg-layer"></div>
      
      <div className="prlx-content-layer">
        <div className="prlx-container">
          <div className="prlx-section-header">
            <h2 className="prlx-section-title">Excellence & Confiance</h2>
            <p className="prlx-section-subtitle">
              Des services premium pour une expérience exceptionnelle
            </p>
          </div>

          <div className="prlx-features-grid">
            <div className="prlx-feature-card">
              <div className="prlx-feature-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M13 2L3 14h6l-4 8 12-10h-6l4-8z"/>
                </svg>
              </div>
              <h3 className="prlx-feature-title">Livraison Rapide</h3>
              <p className="prlx-feature-description">
                Livraison express dans toute l'Algérie sous 3-7 jours ouvrables avec suivi en temps réel
              </p>
            </div>

            <div className="prlx-feature-card">
              <div className="prlx-feature-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <h3 className="prlx-feature-title">Garantie 2 Ans</h3>
              <p className="prlx-feature-description">
                Garantie complète de 2 ans sur tous nos produits pour votre tranquillité d'esprit
              </p>
            </div>

            <div className="prlx-feature-card">
              <div className="prlx-feature-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14,2 14,8 20,8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                  <polyline points="10,9 9,9 8,9"/>
                </svg>
              </div>
              <h3 className="prlx-feature-title">Installation Gratuite</h3>
              <p className="prlx-feature-description">
                Service d'installation professionnel offert sur tous vos achats pour un montage parfait
              </p>
            </div>

            <div className="prlx-feature-card">
              <div className="prlx-feature-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <h3 className="prlx-feature-title">Qualité Certifiée</h3>
              <p className="prlx-feature-description">
                Produits conformes aux normes internationales les plus strictes de qualité et sécurité
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ParallaxFeaturesSection;